import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/travelGuides/travelGuideQueryKeys.ts
var t = e("travelGuides", {
	list: () => ["list"],
	detail: (e) => ["detail", e],
	guestList: (e, t) => [
		"guest",
		"list",
		e ?? "",
		t ?? ""
	],
	guestDetail: (e) => [
		"guest",
		"detail",
		e
	],
	guestShelves: () => ["guest", "shelves"],
	guestDestinations: () => ["guest", "destinations"],
	guestBrowse: (e) => [
		"guest",
		"browse",
		e ?? {}
	],
	moderation: (e) => [
		"moderation",
		"list",
		e ?? {}
	],
	moderationDetail: (e) => [
		"moderation",
		"detail",
		e
	]
});
//#endregion
export { t as travelGuideQueryKeys };
